import counterUp from "./counterUp";

const numbersCounter = () => {
  const containers = document.querySelectorAll(".js-number-container");
  if (containers.length == 0) {
    return;
  }
  const myObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        // return if the element is not intersecting on initial load
        if (!entry.isIntersecting) {
          return;
        }
        // call animation function
        entry.target.classList.add("show");
        let numbers = entry.target.querySelectorAll(".js-number-counter");
        numbers.forEach((number) => {
          counterUp(number, { duration: 2000 });
        });
        // disable observer for that element if you want animation to happen only once
        observer.unobserve(entry.target);
      });
    },
    {
      // trigger intersection when top of the element is 200px inside of the screen
      rootMargin: "0px 0px -200px  0px",
    }
  );
  containers.forEach((container) => {
    myObserver.observe(container);
  });
};

export default numbersCounter;
